module.exports = __webpack_public_path__ + "static/img/otherright.3dc890a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/otherright.png
// module id = 8dx+
// module chunks = 1